import { openNotification } from 'components';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from 'utils/urls';
import { navigate } from 'utils/navigate';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';
import { trackError } from '@proposify/frontend-observability';

export const useGenerateDocumentFromTemplate = ({ assetData }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const generateDocumentHandle = useCallback(async () => {
    if (!assetData) {
      return;
    }

    setIsLoading(true);
    let documentId: string;
    try {
      try {
        const result = await apiDocumentServiceRepository.copyTemplateAsDocument({
          templateId: assetData.content_id,
        });
        documentId = result.documentId;
      } catch (error) {
        trackError('frontend template-editor copyTemplateAsDocument failed', {
          message: error instanceof Error ? error.message : String(error),
          stack: error instanceof Error ? error.stack : undefined,
          errorFrom: 'proposify-frontend',
          cause: 'copyTemplateAsDocument API call failed',
          templateId: assetData.content_id,
        });
        throw error;
      }
    } catch (error) {
      openNotification({
        type: 'error',
        title: t('editor.editor_menu.error_title'),
        description: t('editor.editor_menu.error_description'),
        placement: 'top',
      });
      setIsLoading(false);
      return;
    }
    navigate(`${URLS.document}/${documentId}`);
  }, [assetData, t]);

  return { generateDocumentHandle, isLoading };
};
